<div class="tw-p-4">
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="matp-dialog-title">
    <span class="absolute h-14 w-14 top-0 start-0">デバイス登録確認</span>
  </div>

  <mat-dialog-content class="!tw-pt-2 tw-max-h-1/2">
    <div class="tw-flex tw-w-full tw-justify-center tw-space-x-20">
      <div class="tw-mx-2 tw-w-4/5">
        <div class="tw-mb-3">Qualcomm Database</div>
        <div
          class="tw-border-solid tw-border-gray-200 tw-border-2 tw-h-80 tw-max-h-4/5 tw-overflow-y-scroll tw-w-full"
        >
          <mat-list>
            @for(qualcommDevice of qualcommDeviceList;track qualcommDevice ){
            <mat-list-item>{{ qualcommDevice }}</mat-list-item>
            }
          </mat-list>
        </div>
      </div>

      <div class="tw-mx-2 tw-w-4/5">
        <div class="tw-mb-3">Macnica Database</div>
        <div
          class="tw-border-solid tw-border-gray-200 tw-border-2 tw-h-80 tw-max-h-4/5 tw-overflow-y-scroll tw-w-full"
        >
          <mat-list>
            @for(matpDevice of matpDeviceList;track matpDevice ){
            <mat-list-item>{{ matpDevice }}</mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
    <button id="cancel-btn" mat-raised-button mat-dialog-close class="tw-w-40">
      <mat-icon>close</mat-icon>
      閉じる
    </button>
  </mat-dialog-actions>
</div>
